import { render, staticRenderFns } from "./edit-item-table.vue?vue&type=template&id=96ce0a1e&scoped=true&"
import script from "./edit-item-table.vue?vue&type=script&lang=js&"
export * from "./edit-item-table.vue?vue&type=script&lang=js&"
import style0 from "./edit-item-table.vue?vue&type=style&index=0&id=96ce0a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce0a1e",
  null
  
)

export default component.exports